import { render } from "./ZonesView.vue?vue&type=template&id=063d771c"
import script from "./ZonesView.vue?vue&type=script&lang=js"
export * from "./ZonesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__